import { useNavigate } from "react-router-dom";
import FixHeader from "../component/FixHeader";
import Footer from "../component/Footer";
import Loader from "../component/Loader";

const Faq = () => {
  const navigate = useNavigate()
  return (
    <>
      <div className="site_contain">
        {/* <!-- ====================================== Preloader ===================================== --> */}
        <Loader />
        <FixHeader />
        {/* <!-- ====================================== About Section One ===================================== --> */}
        <section className="section-breadcrumb-img" id="faq-section-one">
          <div className="container breadcrumb-main">
            <h1 className="about-h1-text" data-aos="fade-down">Faq</h1>
            <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
              <li className="line-slash" onClick={() => navigate("/")}>Home</li>
              <li className="line-slash" onClick={() => navigate("/faq")}>Page</li>
              <li className="active-breadcrumb" onClick={() => navigate("/faq")}>Faq</li>
            </ul>
          </div>
        </section>
        {/* <!-- ====================================== FAQ Section Two ===================================== --> */}
        <section className="about-section-two">
          <div className="container overflow-hidden">
            <h2 className="section-heading-text ask-auestion" data-aos="fade-up">
              Frequently Ask <span>Question</span>
            </h2>
            <p className="section-sub-text tempus since" data-aos="fade-up">
              Ac quis pretium consectetur urna dolor. Cursus et amet neque ullamcorper. Cursus tempus accumsan eu nibh.
            </p>
            <div className="row FAQ-section-row">
              <div className="col-xxl-8">
                <div className="accordion" id="accordion2">
                  <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                    <div className="accordion-header" id="faqOne">
                      <button className="accordion-button accordion-button-collapsed collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#faqcollapseOne">What is your review policy?
                      </button>
                    </div>
                    <div id="faqcollapseOne" className="accordion-collapse collapse" aria-labelledby="faqOne" data-bs-parent="#accordion2">
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                    <div className="accordion-header" id="faqTwo">
                      <button className="accordion-button accordion-button-collapsed collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#faqcollapseTwo">What is the typical turnaround time for content?
                      </button>
                    </div>
                    <div id="faqcollapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordion2">
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                    <div className="accordion-header" id="faqThree">
                      <button className="accordion-button accordion-button-collapsed collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#faqcollapseThree">What types of content can I order?
                      </button>
                    </div>
                    <div id="faqcollapseThree" className="accordion-collapse collapse" data-bs-parent="#accordion2">
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                    <div className="accordion-header" id="faqFour">
                      <button className="accordion-button accordion-button-collapsed collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqcollapseFour"> Who are the Crowd Content writers?
                      </button>
                    </div>
                    <div id="faqcollapseFour" className="accordion-collapse collapse" data-bs-parent="#accordion2">
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                    <div className="accordion-header" id="faqFive">
                      <button className="accordion-button accordion-button-collapsed collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#faqcollapseFive">How much does a website cost?
                      </button>
                    </div>
                    <div id="faqcollapseFive" className="accordion-collapse collapse" data-bs-parent="#accordion2">
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                    <div className="accordion-header" id="faqSix">
                      <button className="accordion-button accordion-button-collapsed collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#faqcollapseSix">What happens if I don't like the content?
                      </button>
                    </div>
                    <div id="faqcollapseSix" className="accordion-collapse collapse" data-bs-parent="#accordion2">
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};
export default Faq;
